import themes from 'Styles/Themes';

export type ThemePreference = 'auto' | 'light' | 'dark';

const storageKey = 'tdarr.ui.theme';
const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

export function getThemePreference(): ThemePreference {
  const stored = localStorage.getItem(storageKey);
  return stored === 'light' || stored === 'dark' ? stored : 'auto';
}

export function applyTheme(preference = getThemePreference()) {
  const resolved = preference === 'auto' ? (mediaQuery.matches ? 'dark' : 'light') : preference;
  Object.entries(themes[resolved]).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--${key}`, value as string);
  });
  document.documentElement.dataset.theme = resolved;
  document.documentElement.dataset.themePreference = preference;
}

export function setThemePreference(preference: ThemePreference) {
  if (preference === 'auto') {
    localStorage.removeItem(storageKey);
  } else {
    localStorage.setItem(storageKey, preference);
  }
  applyTheme(preference);
  window.dispatchEvent(new CustomEvent('tdarr:theme', { detail: preference }));
}

export function watchTheme() {
  const onSystemThemeChange = () => {
    if (getThemePreference() === 'auto') applyTheme('auto');
  };
  const onStoredThemeChange = () => applyTheme();
  mediaQuery.addEventListener('change', onSystemThemeChange);
  window.addEventListener('storage', onStoredThemeChange);
  return () => {
    mediaQuery.removeEventListener('change', onSystemThemeChange);
    window.removeEventListener('storage', onStoredThemeChange);
  };
}
